import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">Info</h3>
          <ul className="footer-links">
            <li>
              <Link to="/contact" onClick={toTop}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={toTop}>
                About
              </Link>
            </li>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Shipping
              </Link>
            </li>
            <li>
              <Link to="/returns" onClick={toTop}>
                Returns
              </Link>
            </li>
            <li>
              <Link to="/terms" onClick={toTop}>
                Terms
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={toTop}>
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/cookies" onClick={toTop}>
                Cookies
              </Link>
            </li>
            <li>
              <Link to="/faqs" onClick={toTop}>
                FAQs
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3 className="footer-title">Policies</h3>
          <ul className="footer-links">
            <li><Link to="/policies" onClick={toTop}>Policy Centre</Link></li>
            <li><Link to="/payments" onClick={toTop}>Payments &amp; Pricing</Link></li>
            <li><Link to="/cancellations" onClick={toTop}>Order Cancellations</Link></li>
            <li><Link to="/warranty" onClick={toTop}>Warranty &amp; Faulty Goods</Link></li>
            <li><Link to="/product-care" onClick={toTop}>Product Care &amp; Safety</Link></li>
            <li><Link to="/promotions" onClick={toTop}>Promotions</Link></li>
            <li><Link to="/gift-cards" onClick={toTop}>Gift Cards &amp; Store Credit</Link></li>
            <li><Link to="/data-collection" onClick={toTop}>Data Collection Notice</Link></li>
            <li><Link to="/intellectual-property" onClick={toTop}>Intellectual Property</Link></li>
            <li><Link to="/accessibility" onClick={toTop}>Accessibility</Link></li>
            <li><Link to="/security" onClick={toTop}>Security &amp; Fraud</Link></li>
            <li><Link to="/complaints" onClick={toTop}>Complaints</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3 className="footer-title">Get in touch</h3>
          <div className="contact-info">
            <div className="contact-item">
              Email:
              <span>gear@mefurvexo.monster</span>
            </div>
            <div className="contact-item">
              Address:
              <span>
                CUPFORD HOUSE<br />
                QUEEN'S ROAD WEST 108<br />
                CENTRAL AND WESTERN DISTRICT<br />
                HONG KONG
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span className="copyright">© 2026 mefurvexo</span>
      </div>
    </footer>
  );
}

export default Footer;
